import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from 'shared/lib/cn';

const btn = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[var(--radius-2)] font-body text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/60 disabled:pointer-events-none disabled:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        contained: 'bg-brand text-ground hover:bg-brand-strong',
        outlined: 'border border-brand text-brand hover:bg-brand/10',
        neutral: 'bg-surface-high text-ink hover:bg-surface-overlay border border-hairline/20',
        text: 'text-brand hover:bg-brand/10',
        danger: 'bg-danger text-ink hover:bg-danger/90',
      },
      size: {
        sm: 'h-8 px-3 text-xs',
        md: 'h-9 px-4',
        lg: 'h-10 px-6',
      },
    },
    defaultVariants: { variant: 'contained', size: 'md' },
  },
);

export type BtnProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof btn> & { asChild?: boolean };

export const Btn = React.forwardRef<HTMLButtonElement, BtnProps>(
  ({ className, variant, size, asChild = false, type = 'button', ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return <Comp ref={ref} type={asChild ? undefined : type} className={cn(btn({ variant, size }), className)} {...props} />;
  },
);
Btn.displayName = 'Btn';
